<template>
    <div class="container d-flex justify-content-center">
        <div class="flex-grow-1" style="max-width: 617px; min-width: 0">
            <div class="spacer-64"></div>
            <div class="step-title text-center">{{$trans('storefront::flexible_packaging.summary')}}</div>
            <div class="spacer-56"></div>

            <div>
                <div class="d-flex flex-column">
                    <div class="fs-3 fw-700 mb-2">{{$trans('storefront::flexible_packaging.information')}}</div>
                    <div v-for="(value, key) in store.data" :key="key">
                        <template v-if="getDataMapValue(key, 'step', null) !== 6">
                            <div class="d-flex value-edit" v-if="show({key, value})" @click="gotoStep(dataMap[key])">
                                <span class="fw-500 mr-2">{{$trans(`storefront::flexible_packaging.${key}`)}}:</span> <span class="text-muted">{{getValue({key, value})}}</span>
                            </div>
                        </template>
                    </div>
                </div>

                <div class="spacer-32"></div>

                <div class="d-flex flex-column">
                    <div class="fs-3 fw-700 mb-2">{{$trans('storefront::flexible_packaging.details')}}</div>
                    <div v-for="(value, key) in store.data" :key="key">
                        <template v-if="getDataMapValue(key, 'step', null) === 6">
                            <div class="d-flex value-edit flex-wrap" v-if="show({key, value})" @click="gotoStep(dataMap[key])">
                                <span class="fw-500 mr-2">{{$trans(`storefront::flexible_packaging.${key}`)}}:</span> <span class="text-muted">{{getValue({key, value})}}</span>
                            </div>
                        </template>
                    </div>
                </div>

                <div v-if="store.files.length > 0">
                    <div class="spacer-32"></div>
                    <div class="fs-3 fw-700 mb-2">{{$trans('storefront::flexible_packaging.uploaded_files')}}</div>
                    <scroll-box class="mt-2" style="max-height: 300px">
                        <file-upload id="file-upload" :files="store.files" :accept="store.mediaOptions.mimes"></file-upload>
                    </scroll-box>
                </div>
            </div>

            <div class="spacer-64"></div>

            <div class="d-flex flex-column-reverse flex-sm-row justify-content-sm-end gap-2">
                <button type="button" class="btn btn-outline-secondary text-uppercase" style="min-width: 150px" @click="store.previousStep">{{$trans('storefront::flexible_packaging.previous')}}</button>
                <button type="button" class="btn btn-secondary text-uppercase" style="min-width: 222px" @click="handleNext">
                    <template v-if="!store.loading">
                        {{$trans('storefront::flexible_packaging.finish_your_request')}}
                    </template>

                    <template v-else>
                        <div class="spinner-border spinner-border-md text-light" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </template>
                </button>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .value-edit {
        cursor: pointer;
    }

    .value-edit:hover {
        .text-muted {
            text-decoration: underline;
        }

        &::after {
            display: inline-block;
            content: "\f044";
            margin-left: 0.5rem;

            font-family: Line Awesome Free;
            font-weight: 900;
        }
    }
</style>

<script>
import {useFlexiblePackagingStore} from "../../js/store";
import FlexiblePackagingOption from "../inc/FlexiblePackagingOption";

export default {
    components: {FlexiblePackagingOption},
    setup() {
        const store = useFlexiblePackagingStore();
        return {
            store: store,
        }
    },
    data() {
        return {
            // TODO load from FlexiblePackageForm DATA_MAP
            //HAS TO HAVE THE SAME FIELDS AS STORE.DATA
            dataMap: {
                category: {
                    translatable: true,
                    step: 1,
                },
                pouchType: {
                    translatable: true,
                    step: 2
                },
                unwind: {
                    translatable: true,
                    step: 2
                },

                //QUESTIONAIRE
                pouch_size: {
                    translatable: false,
                    step: 3,
                    question: 1,
                },
                hole_in_pouch: {
                    translatable: true,
                    step: 3,
                    question: 2,
                },
                zipper: {
                    translatable: true,
                    step: 3,
                    question: 3,
                },
                tear_notch: {
                    translatable: true,
                    step: 3,
                    question: 4,
                },
                rounded_corners: {
                    translatable: true,
                    step: 3,
                    question: 5,
                },
                seal_width: {
                    translatable: true,
                    step: 3,
                    question: 6,
                },
                pouch_valve: {
                    translatable: true,
                    step: 3,
                    question: 7
                },
                material: {
                    translatable: true,
                    step: 3,
                    question: 8,
                },

                sku: {
                    translatable: false,
                    step: 4
                },

                total_pouch_quantity_to_quote_price: {
                    translatable: false,
                    step: 5
                },

                first_name: {
                    translatable: false,
                    step: 6
                },
                last_name: {
                    translatable: false,
                    step: 6
                },
                email: {
                    translatable: false,
                    step: 6
                },
                phone: {
                    translatable: false,
                    step: 6
                },
                company: {
                    translatable: false,
                    step: 6
                },
                industry: {
                    translatable: false,
                    step: 6
                },
                country: {
                    translatable: false,
                    step: 6
                },
                city: {
                    translatable: false,
                    step: 6
                },
                order_quantity: {
                    translatable: false,
                    step: 6
                },
                how_did_you_find_us: {
                    translatable: false,
                    step: 6
                },
                files: {
                    translatable: false,
                    step: 5
                }
            },
        }
    },
    methods: {
        handleNext() {
            this.saveData().then(() => {
                this.store.nextStep();
            }).catch(error => {
                this.store.showFormSubmitErrors(error);
            });
        },
        saveData() {
            let app = this;
            app.store.loading = true;
            return new Promise((resolve, reject) => {
                // ---- Do not change again, breaks file upload ----
                let data = JSON.parse(JSON.stringify(app.store.data));
                data.files = app.store.files;
                // --------------------------------------
                $.ajax({
                    method: "POST",
                    url: route("flexible_package_types.store"),
                    data: data
                })
                    .then(() => {
                        app.store.loading = false;

                        resolve();
                    })
                    .catch((xhr) => {
                        app.store.loading = false;

                        reject(xhr.responseJSON);
                    });
            });
        },
        show({key, value}) {
            if (value === null) return false;

            if (!this.dataMap[key]) {
                console.warn(`Key: ${key} does not exist!`);
                return false;
            }

            if (!this.store.steps[this.dataMap[key].step-1].enabled) return false;

            if (this.dataMap[key].step === 6 && value === "") return false;

            return true;
        },
        getValue({key, value}) {
            if (value === '') {
                return this.$trans(`storefront::flexible_packaging.empty`);
            }

            if (this.dataMap[key].translatable) {
                return this.$trans(`storefront::flexible_packaging.${value}`);
            }

            return value;
        },
        gotoStep(data) {
            this.store.currentStep = data.step-1;

            if (data.hasOwnProperty('question')) {
                this.store.currentQuestion = data.question;
            }
        },
        getDataMapValue(key, property, defaultValue) {
            return (this.dataMap[key] && this.dataMap[key][property]) ? this.dataMap[key][property] : defaultValue;
        },
    }
}
</script>
